"use client"

import type { ReactNode } from "react"
import type { CommonButtonProps } from "@/components/Button/regular-button.types"
import type { LinkProps } from "@/components/Link/Link.component"
import { Link } from "@/components/Link/Link.component"
import { useFeatureFlag } from "@/contexts/feature-flag/feature-flag-context"
import { useCurrentUrl } from "@/hooks/use-current-url.hook"
import { useAuthentication } from "@/vendors/authentication/hooks/use-authentication.hook"

type LoginLink = Pick<CommonButtonProps, "position"> & {
  readonly className?: string
  readonly children: ReactNode
  readonly redirectTo?: string
  readonly variant?: LinkProps["variant"]
  readonly testId?: string
}

export function LoginLink({
  children,
  className,
  position,
  redirectTo,
  variant = null,
  testId = "lg-a",
}: LoginLink) {
  const { urls } = useAuthentication()
  const { relative: currentRelativeUrl } = useCurrentUrl()

  const isPaywallDisabled = useFeatureFlag("disable-paywall")
  if (!urls) {
    return null
  }

  const { createLogin } = urls
  const href = createLogin(redirectTo ?? currentRelativeUrl)

  if (isPaywallDisabled || !href) {
    return null
  }

  return (
    <Link
      className={className}
      href={href}
      openInNewTab={false}
      position={position}
      testId={testId}
      variant={variant}
    >
      {children}
    </Link>
  )
}
